/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/AttachmentPanel.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays attachments uploaded during work execution.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Display uploaded attachments
 * ✓ Upload new attachment
 * ✓ Preview attachment
 * ✓ Download attachment
 * ✓ Delete attachment (Future)
 *
 ******************************************************************************/

import React from "react";

export default function AttachmentPanel({

    attachments = [],

    disabled = false,

    onUpload,

    onView,

    onDownload,

}) {

    return (

        <div className="card shadow-sm border-0 mb-4">

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <div className="card-header bg-white">

                <div className="d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">

                        Attachments

                    </h5>

                    <button

                        type="button"

                        className="btn btn-primary btn-sm"

                        disabled={disabled}

                        onClick={onUpload}

                    >

                        <i className="fas fa-upload me-2" />

                        Upload

                    </button>

                </div>

            </div>

            {/* ====================================================== */}
            {/* BODY */}
            {/* ====================================================== */}

            <div className="table-responsive">

                <table className="table table-hover align-middle mb-0">

                    <thead className="table-light">

                        <tr>

                            <th width="70">

                                #

                            </th>

                            <th>

                                File Name

                            </th>

                            <th>

                                Uploaded By

                            </th>

                            <th>

                                Uploaded On

                            </th>

                            <th className="text-end">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            attachments.length === 0 && (

                                <tr>

                                    <td

                                        colSpan="5"

                                        className="text-center py-4 text-muted"

                                    >

                                        No attachments uploaded.

                                    </td>

                                </tr>

                            )

                        }

                        {

                            attachments.map((file, index) => (

                                <tr key={file.id}>

                                    <td>

                                        {index + 1}

                                    </td>

                                    <td>

                                        <i className="fas fa-paperclip me-2 text-secondary" />

                                        {file.file_name}

                                    </td>

                                    <td>

                                        {file.uploaded_by}

                                    </td>

                                    <td>

                                        {file.uploaded_at}

                                    </td>

                                    <td className="text-end">

                                        <button

                                            className="btn btn-outline-primary btn-sm me-2"

                                            onClick={() =>

                                                onView?.(file)

                                            }

                                        >

                                            View

                                        </button>

                                        <button

                                            className="btn btn-outline-success btn-sm"

                                            onClick={() =>

                                                onDownload?.(file)

                                            }

                                        >

                                            Download

                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}